import { makeStyles } from 'tss-react/mui';
import { darken } from '@mui/material/styles';
export const useStyles = makeStyles<{
  color?: string;
  fullWidth: boolean;
  border?: string;
  isEsia?: boolean;
}>()((theme, { color, fullWidth, border, isEsia }) => ({
  button: {
    position: 'relative',
    paddingTop: theme.tokens.spacing['16'],
    paddingLeft: isEsia
      ? theme.tokens.spacing['16']
      : theme.tokens.spacing['24'],
    paddingBottom: theme.tokens.spacing['16'],
    paddingRight: isEsia
      ? theme.tokens.spacing['16']
      : theme.tokens.spacing['24'],
    height: theme.px(56),
    width: fullWidth ? '100%' : 'auto',
    fontWeight: 600,
    fontSize: theme.tokens.typography.variant.body1.fontSize,
    lineHeight: '1.5em',
    color: theme.tokens.colors.text.dark.primary,
    backgroundColor: color || theme.tokens.colors.original.brand.primary,
    border: border || 'none',
    borderRadius: theme.tokens.radius.l,
    cursor: 'pointer',

    '&:hover': {
      backgroundColor: color ? darken(color, 0.1) : undefined,
    },

    '&:disabled': {
      backgroundColor: theme.tokens.colors.bg.greyscale.primary,
      color: theme.tokens.colors.text.light.tertirary,
      cursor: 'default',
    },
  },
  loading: {
    position: 'absolute',
    top: 'calc(50% - 9.4px)',
    left: 'calc(50% - 9.4px)',
  },
}));
